import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button'];

  connect() {
    if (!this.hasButtonTarget || !this.observedElement) return;

    this.buttonTarget.dataset.action = 'click->scroll-top--component#click';

    const observer = new IntersectionObserver(([element]) => {
      if (element.isIntersecting) {
        this.buttonTarget.classList.add('opacity-0', 'pointer-events-none');
      } else {
        this.buttonTarget.classList.remove('opacity-0', 'pointer-events-none');
      }
    });

    observer.observe(this.observedElement);
  }

  click() {
    this.observedElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  get observedElement() {
    const header = document.querySelector('header');

    if (header?.classList.contains('sticky'))
      return document.querySelector('#top');

    return header;
  }
}
